export default __webpack_public_path__ + "static/reviews-d8b631fa62f2a48593106712c97048e6.svg";